import DeltaE from 'delta-e';

const findClosestGoldenPalette = (labColor, goldenPalettes) => {
  let coefficient = Infinity;
  let colors = goldenPalettes[0];
  let closestReference = -1;
  for (let paletteIndex = 0; paletteIndex < goldenPalettes.length; paletteIndex += 1)
    for (
      let colorIndex = 0;
      colorIndex < goldenPalettes[paletteIndex].length && coefficient > 0;
      colorIndex += 1
    ) {
      const paletteColor = goldenPalettes[paletteIndex][colorIndex];
      const convertLabFormat = ({ lightness, a, b }) => ({
        L: lightness,
        A: a,
        B: b,
      });

      const deltaE = DeltaE.getDeltaE00(convertLabFormat(labColor), convertLabFormat(paletteColor));

      if (deltaE < coefficient) {
        coefficient = deltaE;
        colors = goldenPalettes[paletteIndex];
        closestReference = colorIndex;
      }
    }
  return { colors, closestReference };
};

export default findClosestGoldenPalette;
